module.exports = __webpack_public_path__ + "static/img/进入直播间备份.630b0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live/进入直播间备份.png
// module id = WpZb
// module chunks = 1